// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconUmbrella = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M13 4.055V3h-2v1.055A9 9 0 003 13v1h2a1 1 0 112 0h2a1 1 0 112 0v5a3 3 0 106 0h-2a1 1 0 11-2 0v-5a1 1 0 112 0h2a1 1 0 112 0h2v-1a9 9 0 00-8-8.945m5.737 7.036a7.003 7.003 0 00-13.474 0A3 3 0 018 11.764 3 3 0 0110 11c.768 0 1.47.289 2 .764A3 3 0 0114 11c.768 0 1.47.289 2 .764a2.99 2.99 0 012.737-.673"
    />
  );
export default SvgIconUmbrella;
